/**
 * B2C Mother API client. Isolated from doctor authApi to prevent mixing tokens.
 * Uses its own token key (mom_auth_token) + fetch helper — does NOT share doctor's token.
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MOM_TOKEN_KEY = 'mom_auth_token';

export const setMomToken = (token) => localStorage.setItem(MOM_TOKEN_KEY, token);
export const getMomToken = () => localStorage.getItem(MOM_TOKEN_KEY);
export const clearMomToken = () => localStorage.removeItem(MOM_TOKEN_KEY);

const momFetch = async (path, options = {}) => {
  const token = getMomToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(options.headers || {}),
  };
  const res = await fetch(`${API}${path}`, { ...options, headers });
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      msg = body.detail || body.message || msg;
    } catch {}
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
};

export const momApi = {
  register: (data) => momFetch('/mom/auth/register', { method: 'POST', body: JSON.stringify(data) }),
  login: (data) => momFetch('/mom/auth/login', { method: 'POST', body: JSON.stringify(data) }),
  me: () => momFetch('/mom/me'),
  updateProfile: (data) => momFetch('/mom/me', { method: 'PATCH', body: JSON.stringify(data) }),
  saveOnboarding: (data) => momFetch('/mom/onboarding', { method: 'POST', body: JSON.stringify(data) }),
  getCredits: () => momFetch('/mom/credits'),
};
